module.exports = __webpack_public_path__ + "img/优异的数据搜索能力.d5494b4c.png";